import axios from 'axios';
import { saveUserAction } from './saveUserAction';

axios.defaults.withCredentials = true;

export async function sendMail(data) {
  try {
    const response = await axios.post(`${import.meta.env.VITE_APP_API_URL}send-mail`,
      { data });
    saveUserAction({ id_accion: 3, detalles_accion: `Comentarios: ${data.comentarios}` });
    return response.data;

  } catch (error) {
    console.error('Error al enviar mail', error);
  }
}